import React from "react";
import { useLocation } from "react-router-dom";
import toast from "react-hot-toast";

import BrandingControls from "./branding";
import Configuration from "../../features/settings/configuration";

import { useViewSettingsList } from "../../hooks/settings/viewAllSettings";
import { useSettingsUpdate } from "../../hooks/settings/updateSettings";

import "../../assets/styles/settings.css";
import Button from "../../components/common/button";
import { getPageTitle } from "../../utils/getPageTitle";

const Settings = () => {
  const {
    data: settingsData,
    isLoading,
    isError,
  } = useViewSettingsList();

  // React Query v5
  const {
    mutate: updateSettings,
    isPending: isUpdating,
  } = useSettingsUpdate();

  const location = useLocation();

  // Get settings object
  const settings = Array.isArray(settingsData?.data)
    ? settingsData.data[0]
    : settingsData?.data || {};

  console.log("Settings Data:", settingsData);
  console.log("Extracted Settings:", settings);


  if (isLoading) {
    return (
      <div className="settings-page">
        <div className="settings-container">
          <p>Loading settings...</p>
        </div>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="settings-page">
        <div className="settings-container">
          <p>Failed to load settings</p>
        </div>
      </div>
    );
  }

  return (
    <div className="settings-page">
      <div className="settings-container">
        <div className="page-body">
          <div className="page-header">
            <h1 className="page-title">
              {getPageTitle(location.pathname)}
            </h1>

            <p
              style={{
                color: "rgb(85, 85, 85)",
                fontSize: "13px",
              }}
            >
              Manage your settings
            </p>
          </div>

        </div>

      <BrandingControls
        settings={settings}
        onUpdate={updateSettings}
        isUpdating={isUpdating}
      />

      <Configuration
        settings={settings}
        onUpdate={updateSettings}
        isUpdating={isUpdating}
      />
      </div>
    </div>
  );
};

export default Settings;